/** Canonical entity data lives only in the active local session map. */
export interface EntityRecord {
  entityId: string;
  type: string;
  canonicalValue: string;
  token: string;
}

export interface OccurrenceRecord {
  entityId: string;
  originalValue: string;
  startUtf16: number;
  endUtf16: number;
}

/** Selection offsets are half-open UTF-16 code-unit offsets into `protect` input. */
export interface ProtectionSelection {
  startUtf16: number;
  endUtf16: number;
  type: string;
  /** Deliberately link aliases or variants to an existing canonical entity. */
  entityId?: string;
  /** Used as the entity's restoration value when it is first seen. */
  canonicalValue?: string;
}

export interface PlaceholderSessionOptions {
  /** Test-friendly injected scope nonce; production uses crypto.getRandomValues(). */
  nonce?: string;
  /** Existing text/tokens to avoid colliding with before any replacement. */
  reservedTokens?: Iterable<string>;
}

export interface ProtectionResult {
  text: string;
  entities: readonly EntityRecord[];
  occurrences: readonly OccurrenceRecord[];
}

export interface RestorationResult {
  text: string;
  replacements: number;
}

export class InvalidSelectionError extends Error {
  readonly code = "INVALID_SELECTION";
  constructor() {
    super("Selections must be valid, non-overlapping spans.");
    this.name = "InvalidSelectionError";
  }
}

export class ClearedPlaceholderSessionError extends Error {
  readonly code = "SESSION_CLEARED";
  constructor() {
    super("This placeholder session has been cleared.");
    this.name = "ClearedPlaceholderSessionError";
  }
}
